import $ from 'jquery';
import {connectSortBy} from 'instantsearch.js/es/connectors';

const renderCustomSortBy = (renderOptions, isFirstRender) => {
    const {
        options,
        currentRefinement,
        refine,
        widgetParams,
    } = renderOptions;

    let $container = $(widgetParams.container);

    if (isFirstRender) {
        const currentOption = options.find((option) => option.value === currentRefinement);

        const body = document.createElement('div');
        body.className = 'algolia-sort-body';

        const optionList = document.createElement('ul');
        optionList.className = 'algolia-sort-unordered-list';

        const header = document.createElement('div');
        header.className = 'algolia-search-panel-header';
        header.innerHTML = `
            <div class="algolia-search-panel-header__headline">
                <span>${widgetParams.translations['algolia.search.sort.title']}:</span>
                <span class="algolia-sort-value">${currentOption.label}</span>
            </div>
            <button class="js-algolia-search-close btn-reset algolia-search-panel-header__close"
                    aria-label="${widgetParams.translations['algolia.search.filter.close']}">
                <svg class="icon icon-close">
                    <use xlink:href="#icon-close"></use>
                </svg>
            </button>`;

        body.appendChild(header);
        body.appendChild(optionList);
        widgetParams.container.appendChild(body);

        $container.find('.algolia-sort-value').text(currentOption.label);
        $container.find('.algolia-sort-btn').on('click', function () {
            $(this).closest('.algolia-sort').toggleClass('active');
            if ($(this).parent('#js-sorting-mobile').length) {
                $('body').removeClass('algolia-overlay-active');
            }
        });
    }

    const optionList = widgetParams.container.querySelector('ul');

    optionList.innerHTML = `${options.map(
        option => `<li class="algolia-sort-option" data-option-value="${option.value}">${option.label}</li>`
    ).join('')}`;

    $container.find('.algolia-sort-option').on('click', function (e) {
        const $this = $(this);
        const $sort = $this.closest('.algolia-result');

        $sort.find('.algolia-sort-value').text($this.text());
        refine($this.attr('data-option-value'));
        // Discuss if only the desktop sorting menu should close after a change
        // $sort.find('.algolia-sort:not(.algolia-sort--mobile)').removeClass('active');
        $sort.find('.algolia-sort').removeClass('active');
    });
};

// Create the custom widget
const customSortBy = connectSortBy(
    renderCustomSortBy
);

export {customSortBy};
